import { campaignTypes } from "@campaign/campaign-types.di";
import { CropTypes } from "@campaign/domain/models/crop-type.model";
import type { CampaignRepository } from "@campaign/domain/repositories/campaign.repository";
import { inject, injectable } from "inversify";

@injectable()
export class CropTypeGetAllUseCase {
    constructor(
        @inject(campaignTypes.repositories.CampaignRepository)
        private readonly campaignRepository: CampaignRepository,
    ) {}

    async execute(): Promise<CropTypes> {
        const cropTypeResult = await this.campaignRepository.getAllCropTypes();

        if (cropTypeResult.isErr()) {
            throw new Error("Error getting crop types");
        }

        return cropTypeResult.match(
            (cropTypes) => cropTypes,
            () => CropTypes.empty(),
        );
    }
}
